import { JsonObject, JsonProperty } from 'json2typescript';
import { NotBlank } from '@hvlng/framework-bff/core';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { PerEmployeeSubtypeTextModel } from './per-employee-subtype-text-model';
import { PerEmployeeTypeModel } from './per-employee-type-model';

@JsonObject('KovanHrPerEmployeeSubtypeModel')
export class PerEmployeeSubtypeModel extends HvlBaseModel {
    @NotBlank()
    @JsonProperty('employeeSubtypeTextId', Number, true)
    employeeSubtypeTextId: number = null;

    @JsonProperty('employeeSubtypeText', PerEmployeeSubtypeTextModel, true)
    employeeSubtypeText: PerEmployeeSubtypeTextModel = null;

    @NotBlank()
    @JsonProperty('perEmployeeTypeId', Number, true)
    perEmployeeTypeId: number = null;

    @JsonProperty('perEmployeeType', PerEmployeeTypeModel, true)
    perEmployeeType: PerEmployeeTypeModel = null;

    get combinedTypeName() {
        return `${this.perEmployeeType?.longText} - ${this.employeeSubtypeText?.longText}`;
    }
}
